import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Tooltip from "react-bootstrap/Tooltip";
import Sidebar from "../../partials/aside/Sidebar";
import CategorySitePublisherTopic from "../../sections/publisher/CategorySitePublisherTopic";
import TitleBar from "../../partials/content/TitleBar";
import ListUserCustomerCoWorker from "./ListUserCustomerCoWorker";
import ButtonDisable from "../../partials/other/ButtonDisable";

const typeUserString = {
  REAL: 1,
  LEGAL: 2,
};
export default function ShowInfoCustomerCoworker() {
  const params = useParams();

  const customerCoworkerID = params.id;
  let user = ListUserCustomerCoWorker.filter(
    (user) => user.id == customerCoworkerID
  );
  user = user[0];
  const [typeUser, setTypeUser] = useState(user.type);

  const popover = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      <span style={{ fontFamily: "IRANSansWeb" }}>
        <span>در این</span>
        <span>
          <Link
            className="px-1 d-inline-block"
            target="_blank"
            to="/publishers/list-category-site-publisher"
          >
            صفحه
          </Link>
        </span>
        <span>میتوانید تمامی دسته های صنفی را مشاهده کنید.</span>
      </span>
    </Tooltip>
  );

  const showSelectCategorySitePublisher = () => {
    return (
      <select className="form-control">
        {CategorySitePublisherTopic.map((category) => {
          return <option>{category.title}</option>;
        })}
      </select>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="ویرایش کاربر مشتری همکار" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body" id="fill-info-user">
              <div className="text-left">
                <Link className="text-white" to="/user/all-customer-coworker">
                  <div className="btn btn-primary">
                    <span>
                      <span className="text-white">بازگشت</span>
                    </span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left" aria-hidden="true"></i>
                    </span>
                  </div>
                </Link>
              </div>
              <div>
                <form>
                  <div className="d-flex">
                    <div className="w-50 form-group">
                      <label>ایمیل</label>
                      <span class="px-2">:</span>
                      {user.email}
                    </div>
                  </div>

                  <div className="d-flex">
                    <div className="w-50 form-group">
                      <label>شماره موبایل</label>
                      <span class="text-danger">*</span>
                      <input
                        type="number"
                        className="form-control"
                        id="mobile"
                        placeholder="09121234567"
                        defaultValue={user.mobile}
                        required
                      />
                    </div>
                    <div className="w-50 form-group px-2">
                      <label>دسته صنفی </label>
                      <span class="text-danger">*</span>
                      {showSelectCategorySitePublisher()}
                    </div>
                  </div>

                  <div className="card-body p-0">
                    <div className="form-group ">
                      <label>نوع کاربر</label>
                      <span class="text-danger">*</span>
                    </div>
                    <div className="d-flex flex-column flex-md-row">
                      <div className="form-group d-flex">
                        <div className="form-check pl-2 ">
                          <input
                            className="form-check-input hover"
                            type="radio"
                            name="type-user"
                            id="real-person"
                            defaultChecked={user.type === typeUserString.REAL}
                            onChange={(e) => {
                              setTypeUser(typeUserString.REAL);
                            }}
                          />
                          <label
                            className="form-check-label hover"
                            for="real-person"
                          >
                            شخص حقیقی
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input hover"
                            type="radio"
                            name="type-user"
                            id="legal-person"
                            defaultChecked={user.type === typeUserString.LEGAL}
                            onChange={(e) => {
                              setTypeUser(typeUserString.LEGAL);
                            }}
                          />
                          <label
                            className="form-check-label hover"
                            for="legal-person"
                          >
                            شخص حقوقی
                          </label>
                        </div>
                      </div>
                    </div>
                    <div>
                      <hr />
                    </div>
                    <div className="d-flex flex-column flex-md-row">
                      {typeUser == typeUserString.REAL ? (
                        <>
                          {" "}
                          <div className="form-group ">
                            <label>
                              نام
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="first-name"
                              placeholder="نام"
                              defaultValue={user.first_name}
                              required
                            />
                          </div>
                          <div className="form-group">
                            <label>نام خانوادگی</label>
                            <span className="text-danger">*</span>
                            <input
                              type="text"
                              className="form-control"
                              id="last-name"
                              defaultValue={user.last_name}
                              placeholder="نام خانوادگی"
                              required
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="form-group">
                            <label>نام شخص حقوقی</label>
                            <span className="text-danger">*</span>
                            <input
                              type="text"
                              className="form-control"
                              id="first-name"
                              defaultValue={user.first_name}
                              placeholder="نام شخص حقوقی"
                              required
                            />
                          </div>
                        </>
                      )}
                    </div>
                    <div>
                      <hr />
                    </div>
                    {typeUser == typeUserString.REAL ? (
                      <>
                        <div className="d-flex flex-column flex-md-row">
                          <div className="form-group">
                            <label>شماره تلفن ثابت</label>
                            <input
                              type="number"
                              className="form-control"
                              id="phone"
                              name="phone"
                              defaultValue={user.phone}
                              placeholder="شماره تلفن ثابت"
                            />
                          </div>

                          <div className="form-group">
                            <label>کد ملی</label>
                            <input
                              type="number"
                              className="form-control"
                              id="national-code"
                              name="national-code"
                              defaultValue={user.national_code}
                              placeholder="کد ملی"
                            />
                          </div>

                          <div className="form-group">
                            <label>شماره شناسنامه</label>
                            <input
                              type="number"
                              className="form-control"
                              id="identity-number"
                              defaultValue={user.identity_number}
                              name="identity-number"
                              placeholder="شماره شناسنامه"
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    {typeUser == typeUserString.LEGAL ? (
                      <>
                        <div className="d-flex flex-column flex-md-row">
                          <div className="form-group">
                            <label>شماره تلفن ثابت</label>
                            <input
                              type="number"
                              className="form-control"
                              id="phone"
                              name="phone"
                              defaultValue={user.phone}
                              placeholder="شماره تلفن ثابت"
                            />
                          </div>
                          <div className="form-group">
                            <label>شناسه ملی</label>
                            <input
                              type="number"
                              className="form-control"
                              id="identity-national"
                              name="identity-national"
                              defaultValue={user.identity_national}
                              placeholder="شناسه ملی"
                            />
                          </div>

                          <div className="form-group">
                            <label>شماره اقتصادی</label>
                            <input
                              type="number"
                              className="form-control"
                              id="economic-number"
                              name="economic-number"
                              defaultValue={user.economic_number}
                              placeholder="شماره اقتصادی"
                            />
                          </div>

                          <div className="form-group">
                            <label>شماره ثبت</label>
                            <input
                              type="number"
                              className="form-control"
                              id="register-number"
                              name="register-number"
                              defaultValue={user.register_number}
                              placeholder="شماره ثبت"
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    <div className="d-flex flex-column flex-md-row">
                      <div className="form-group">
                        <label>استان</label>
                        <input
                          type="text"
                          id="state"
                          className="form-control"
                          defaultValue={user.state}
                          placeholder="استان"
                        />
                      </div>
                      <div className="form-group">
                        <label>شهر</label>
                        <input
                          type="text"
                          id="city"
                          className="form-control"
                          defaultValue={user.city}
                          placeholder="شهر"
                        />
                      </div>
                      <div className="form-group">
                        <label>شهرستان </label>
                        <input
                          type="text"
                          id="town"
                          defaultValue={user.town}
                          className="form-control"
                          placeholder="شهرستان "
                        />
                      </div>

                      <div className="form-group">
                        <label>کد پستی 10 رقمی </label>
                        <input
                          type="number"
                          id="postal-code"
                          className="form-control"
                          defaultValue={user.postal_code}
                          placeholder="کد پستی "
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-column flex-md-row">
                      <div className="form-group description-user-input">
                        <label>آدرس دقیق</label>
                        <input
                          type="text"
                          id="address"
                          className="form-control"
                          defaultValue={user.address}
                          placeholder="آدرس"
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-column flex-md-row">
                      <div className="form-group description-user-input">
                        <label>توضیحات</label>
                        <textarea
                          type="text"
                          id="description"
                          className="form-control"
                          placeholder="توضیحات"
                          rows="8"
                          defaultValue={
                            user.description ? user.description : ""
                          }
                        ></textarea>
                      </div>
                    </div>
                    <div className="d-flex flex-column flex-md-row">
                      <div className="text-center w-100">
                        <ButtonDisable
                          buttonTagHtml={
                            <span className="btn btn-success opacity-50">
                              {" "}
                              ارسال اطلاعات
                            </span>
                          }
                        ></ButtonDisable>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
